// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageHeader-modulewrapperTwQ","title":"PageHeader-moduletitle1O-","userInfo":"PageHeader-moduleuserInfo2px"};